<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-format-list-text"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="(!isCurrencySellReport) ? $t(type) : ''"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <template #top>
<v-row
      v-if="isCurrencySellReport"
      ref="listSummary"
      class="mx-0 app-list-summary-row currency-report-summary-row"
    >
      <v-col class="pa-0" cols="12">
        <div class="app-list-summary-kpis currency-report-kpis">
          <div class="currency-report-kpi">
            <div class="currency-report-kpi__field">
              <money
                v-model="currencyAmount"
                label=""
                :placeholder="$t('currencyPriceHint')"
                :dense="true"
                :outlined="true"
                :solo="false"
                :clearable="true"
                :hide-details="true"
                :height="32"
                value-when-is-empty=""
                :options="moneyOptions"
              />
            </div>
          </div>
          <div class="currency-report-kpi">
            <div
              class="currency-report-kpi__field currency-report-kpi__autocomplete"
              @focusin="currencyAutocompleteFocused = true"
              @focusout="onCurrencyAutocompleteFocusOut"
            >
              <span
                v-if="!hasReportCurrency && !currencyAutocompleteFocused"
                class="currency-report-kpi__placeholder"
              >{{ $t("currencySelectHint") }}</span>
              <autocomplete
                v-model="reportCurrency"
                title="currency"
                type="currency"
                :outlined="true"
              />
            </div>
          </div>
          <div class="currency-report-kpi-action">
            <v-btn
              class="currency-report-calc-btn"
              color="primary"
              depressed
              height="32"
              :ripple="false"
              :disabled="!canCalculateCurrency"
              @click="calculateCurrencyReport"
            >
              <v-icon left small>mdi-calculator</v-icon>
              {{ $t("calc_") }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        v-column-resize="itemsListColumnPlugins"
        v-column-drag="itemsListColumnPlugins"
        v-column-pin="itemsListColumnPlugins"
        :headers="tableHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" class="pl-action-cell__btn" icon x-small v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item v-if="!item.head.lock" link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item link @click="print(item)">
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type + '/edit/' + item.head.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row"><a @click="edit(item)">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </a></span>
          </div>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat(item.price ? item.price.price : 0) }}
          {{ item.currency.symbol }}
        </template>
        <template v-slot:item.head.doc_header.number="{ item }">
          <a
            v-if="item.head.doc_header"
            @click="openComponent('accountingPrint', item.head.doc_head_id)"
          >
            {{ item.head.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.head.customer.name="{ item }">
          <div class="invoice-list-icon-cell">
            <div class="invoice-list-icon-cell__icon">
              <v-tooltip
                v-if="item.head && item.head.customer"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    class="invoice-list-icon-cell__btn"
                    icon
                    x-small
                    v-on="on"
                    @click="
                      openComponent(
                        'accountingTurnover',
                        item.head.customer.fin_id
                      )
                    "
                  >
                    <v-icon color="teal" class="invoice-list-icon-cell__glyph">
                      mdi-playlist-check
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("turnover") }}</span>
              </v-tooltip>
            </div>
            <div class="invoice-list-icon-cell__body">
              <a
                class="invoice-list-customer-link"
                @click="openComponent('account', item.head.customer_id)"
              >
                {{
                  item.head && item.head.customer
                    ? item.head.customer.name
                    : $t("haveNot")
                }}
              </a>
            </div>
          </div>
        </template>
        <template v-slot:item.product.name="{ item }">
          <div class="invoice-list-icon-cell">
            <div class="invoice-list-icon-cell__icon">
              <v-tooltip v-if="item.product" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    class="invoice-list-icon-cell__btn"
                    icon
                    x-small
                    v-on="on"
                    @click="openComponent('productTurnover', item.product_id)"
                  >
                    <v-icon color="teal" class="invoice-list-icon-cell__glyph">
                      mdi-playlist-check
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("productTurnover") }}</span>
              </v-tooltip>
            </div>
            <div class="invoice-list-icon-cell__body">
              <a
                class="invoice-list-customer-link"
                @click="openComponent('product', item.product_id)"
              >
                {{ item.product ? item.product.name : $t("haveNot") }}
              </a>
            </div>
          </div>
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon v-if="item.pre_invoice == 'active'" color="green"> mdi-check </v-icon>
        </template>
        <template v-slot:item.count="{ item }">
          {{ item.count ? $numberFormat(item.count, 3) : 0 }}
        </template>
        <template v-slot:item.fee="{ item }">
          {{
            $numberFormat(item.fee ? item.fee : 0, "currency", item.head.currency.decimal)
          }}
          <v-chip v-if="Number(item.fee)" small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.tax="{ item }">
          {{
            $numberFormat(item.tax ? item.tax : 0, "currency", item.head.currency.decimal)
          }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{
            $numberFormat(
              item.discount ? item.discount : 0,
              "currency",
              item.head.currency.decimal
            )
          }}
        </template>
        <template v-slot:item.sumCurrency="{ item }">
          {{ $numberFormat(item.sumCurrency, "currency", item.head.currency.decimal) }}
          <v-chip v-if="Number(item.sumCurrency)" small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.sum="{ item }">
          {{
            $numberFormat(
              item.sumMainCurrency ? item.sumMainCurrency : 0,
              "currency",
              tableCurrency.decimal
            )
          }}
          <v-chip v-if="Number(item.sumMainCurrency)" small>
            {{ tableCurrency.name }}
          </v-chip>
        </template>
        <template v-slot:item.cost="{ item }">
          {{
            $numberFormat(
              item.cost ? item.cost : 0,
              "currency",
              tableCurrency.decimal
            )
          }}
          <v-chip v-if="Number(item.cost)" small>
            {{ tableCurrency.name }}
          </v-chip>
        </template>
        <template v-slot:item.content="{ item }">
          {{ item.content ? item.content : "ندارد" }}
        </template>
        <template v-slot:item.dkpc="{ item }">
          {{
            item.productIntegrator && item.productIntegrator.digikalaVariantId
              ? item.productIntegrator.digikalaVariantId
              : ""
          }}
        </template>
        <template v-slot:item.woocommerce="{ item }">
          {{
            item.productIntegrator &&
            (item.productIntegrator.woocommerceVariantId ||
              item.productIntegrator.woocommerceId)
              ? (item.productIntegrator.woocommerceId
                  ? item.productIntegrator.woocommerceId + " - "
                  : "") +
                " " +
                item.productIntegrator.woocommerceVariantId
              : ""
          }}
        </template>
        <template v-slot:item.profit="{ item }">
          {{
            $numberFormat(
              item.profit ? item.profit : 0,
              "currency",
              tableCurrency.decimal
            )
          }}
          <v-chip v-if="Number(item.profit)" small>
            {{ tableCurrency.name }}
          </v-chip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.number="{ item }">
          <a @click="edit(item)">
            {{ item.number }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.serialsCount="{ item }">
          <a @click="onSerialsClick(item)">
            {{ serialsCount(item) }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="(item.head && item.head.tags) || []" />
        </template>
        <template v-slot:body.append>
          <tr
            v-if="isMobile || mobileShow"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${
                isMobile
                  ? 6
                  : Number(showHeaders.length) -
                    (type != 'purchase' && type != 'returnSell' ? 13 : 11) +
                    1
              }`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("count") + ":" : "" }} {{ $numberFormat(totals.count) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("fee") + ":" : "" }} {{ $numberFormat(totals.fee) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("discount") + ":" : "" }}
              {{
                $numberFormat(totals.discount, "currency", tableCurrency.decimal)
              }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("tax") + ":" : "" }}
              {{ $numberFormat(totals.tax, "currency", tableCurrency.decimal) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("sum") + ":" : "" }}
              {{ $numberFormat(totals.sumCurrency) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("sum") + ":" : "" }}
              {{ $numberFormat(totals.sum, "currency", tableCurrency.decimal) }}
            </td>
            <td
              v-if="type != 'purchase' && type != 'returnSell'"
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("pricingFinish") + ":" : "" }}
              {{ $numberFormat(totals.cost, "currency", tableCurrency.decimal) }}
            </td>
            <td
              v-if="type != 'purchase' && type != 'returnSell'"
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("profit") + ":" : "" }}
              {{
                $numberFormat(totals.profit, "currency", tableCurrency.decimal)
              }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 5}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            />
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div v-if="!isMobile && !mobileShow" class="app-list-page-totals">
            <span class="app-list-page-totals__label">{{ $t("sumInPage") }}</span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("count") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.count) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("fee") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.fee) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("discount") }}</span>
              <span class="app-list-page-totals__val">
                {{
                  $numberFormat(
                    totals.discount,
                    "currency",
                    tableCurrency.decimal
                  )
                }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("tax") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.tax, "currency", tableCurrency.decimal) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("sum") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sumCurrency) }}
              </span>
            </span>
            <span
              v-if="type != 'purchase' && type != 'returnSell'"
              class="app-list-page-totals__item"
            >
              <span class="app-list-page-totals__key">{{
                $t("pricingFinish")
              }}</span>
              <span class="app-list-page-totals__val">
                {{
                  $numberFormat(totals.cost, "currency", tableCurrency.decimal)
                }}
              </span>
            </span>
            <span
              v-if="type != 'purchase' && type != 'returnSell'"
              class="app-list-page-totals__item"
            >
              <span class="app-list-page-totals__key">{{ $t("profit") }}</span>
              <span class="app-list-page-totals__val">
                {{
                  $numberFormat(totals.profit, "currency", tableCurrency.decimal)
                }}
              </span>
            </span>
            <span class="app-list-page-totals__item app-list-page-totals__item--final">
              <span class="app-list-page-totals__key">{{ $t("sum") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sum, "currency", tableCurrency.decimal) }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="(!isCurrencySellReport) ? $t(type) : ''"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="printItems"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="invoicePrintDialog"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="invoicePrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint :id-prop="printId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
        <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ itemsListFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("sellFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="account"
                :title="$t('customer')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="product"
                type="productService"
                :title="$t('product')"
                :outlined="true"
              />
              <autocomplete
                v-model="currencyFilter"
                :title="$t('currency')"
                type="currency"
                :filter="true"
                :multiple="true"
              />
              <status v-model="sellStatus" :hideconfig="true" />
              <tag v-model="tag" />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[
                      $vuetify.theme.isDark ? 'dark' : 'light'
                    ].primary
                  "
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[
                      $vuetify.theme.isDark ? 'dark' : 'light'
                    ].primary
                  "
                  @close="setDate"
                />
              </div>
              <money
                v-model="fromAmount"
                :dense="true"
                :label="$t('from') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
              <money
                v-model="toAmount"
                :dense="true"
                :label="$t('until') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-numeric</v-icon>
              {{ $t("accFilterNumberAmount") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <v-text-field
                v-model="fromNumber"
                :label="$t('from') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-text-field
                v-model="toNumber"
                :label="$t('until') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-shape-outline</v-icon>
              {{ $t("productEntrepotFilterGroups") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="group"
                :title="$t('main-group')"
                type="productGroup"
                :data="JSON.stringify({ parent: null, type: 'group' })"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat1"
                :title="$t('other-group')"
                type="productGroup"
                :data="JSON.stringify({ parent: null, type: 'category' })"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat2"
                title="category"
                type="productGroup"
                :data="JSON.stringify({ parent: null, type: 'subcategory' })"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="entrepot"
                title="entrepot"
                type="entrepot"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="accountCategory"
                :title="$t('accountCategory')"
                type="accountCategory"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-if="!isCurrencySellReport"
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--add serial list dialog -->
    <article-serials-dialog
      v-model="serialsDialog"
      :product="serialsDialogItem?.product"
      :serials="articleSerials(serialsDialogItem)"
    />
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import Invoicprint from "./print";
import General from "../../../../Mixins/general";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import ProList from "@/Mixins/proList";
import ProListFrame from "@/components/proList/ProListFrame.vue";
import ProListMobile from "@/components/proList/ProListMobile.vue";
import PrintStudio from "@/modules/print/PrintStudio.vue";
export default {
  name: "invoiceItemList",
  components: {
    ProListFrame,
    ProListMobile,
    PrintStudio,
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    dialogComponent: () => import("../../components/general/dialog/index"),
    ArticleSerialsDialog: () => import("./partial/ArticleSerialsDialog.vue"),
    Invoicprint,
    Print,
    Task,
  },
  mixins: [General, ProList],
  props: ["input", "refId", "mobileShow"],
  data: () => ({
    excelItems: [],
    selected: [],
    invoicePrintDialog: false,
    printDialog: false,
    deletDialog: false,
    registerar: null,
    accountCategory: null,
    entrepot: null,
    cat2: null,
    cat1: null,
    group: null,
    dialogData: null,
    product: null,
    account: null,
    currencyFilter: null,
    currencyAmount: null,
    reportCurrency: null,
    appliedReportCurrency: null,
    moneyOptions: {
      locale: "en-US",
      prefix: "",
      suffix: "",
      precision: 0,
    },
    fromAmount: null,
    toAmount: null,
    fromNumber: null,
    toNumber: null,
    fromDate: null,
    toDate: null,
    printId: null,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    headersMap: null,
    pageCount: 1,
    page: 1,
    printHeaders: [],
    serialsDialog: false,
    serialsDialogItem: null,
    currencyAutocompleteFocused: false,
    listViewportObserver: null,
    listViewportRaf: null,
  }),
  computed: {

    itemsListFilterTitle() {
      var map = {
        sellItemsList: "sellItemsListFilterTitle",
        sellCurrencyItemsList: "sellCurrencyItemsListFilterTitle",
        presaleItemsList: "presaleItemsListFilterTitle",
        purchaseItemsList: "purchaseItemsListFilterTitle",
        returnPurchaseItemsList: "returnPurchaseItemsListFilterTitle",
        returnSellItemsList: "returnSellItemsListFilterTitle",
      };
      var key = map[this.$route.name] || "sellItemsListFilterTitle";
      return this.$t(key);
    },
    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var defs = [
        ["account", app.$t("customer")],
        ["product", app.$t("product")],
        ["currencyFilter", app.$t("currency")],
        ["fromAmount", app.$t("from") + " " + app.$t("amount")],
        ["toAmount", app.$t("until") + " " + app.$t("amount")],
        ["fromNumber", app.$t("from") + " " + app.$t("number")],
        ["toNumber", app.$t("until") + " " + app.$t("number")],
        ["fromDate", app.$t("from") + " " + app.$t("date")],
        ["toDate", app.$t("until") + " " + app.$t("date")],
        ["tag", app.$t("tag")],
        ["sellStatus", app.$t("status")],
        ["group", app.$t("main-group")],
        ["cat1", app.$t("other-group")],
        ["cat2", app.$t("category")],
        ["branch", app.$t("branch")],
        ["entrepot", app.$t("entrepot")],
        ["accountCategory", app.$t("accountCategory")],
        ["registerar", app.$t("registerar")],
      ];
      return defs
        .filter(function (d) {
          if (d[0] === "registerar" && app.isCurrencySellReport) return false;
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: show(app[d[0]]) };
        });
    },
    proListKey () {
      return this.itemsListColumnPersistKey
    },
    proListLocked () {
      return this.itemsListLockedColumns
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    isCurrencySellReport() {
      return this.$route.name === "sellCurrencyItemsList";
    },
    hasReportCurrency() {
      var currency = this.reportCurrency;
      if (!currency) return false;
      if (currency.id || currency.value) return true;
      if (typeof currency === "number") return true;
      if (typeof currency === "object") return false;
      return true;
    },
    canCalculateCurrency() {
      if (!this.isCurrencySellReport) return false;
      var amount = this.currencyAmount;
      var hasAmount =
        amount !== null && amount !== undefined && String(amount).trim() !== "";
      return hasAmount && this.hasReportCurrency;
    },
    tableCurrency() {
      if (this.isCurrencySellReport && this.appliedReportCurrency) {
        var c = this.appliedReportCurrency;
        return {
          name: c.name || c.symbol || "",
          symbol: c.symbol || c.name || "",
          decimal:
            c.decimal != null ? c.decimal : this.$store.state.currency.decimal,
        };
      }
      return this.$store.state.currency;
    },
    printItems() {
      return this.items.map((item) => {
        return {
          ...item,
          product: {
            ...item.product,
            unit_fame: item.product?.unit?.fame ?? "",
          },
          head: {
            ...item.head,
            doc_header_number: item.head?.doc_header?.number ?? "",
            customer_name: item.head?.customer?.name ?? "",
          },
          registerar_name: item.user?.name || item.head?.user?.name || "",
          serialsCount: this.serialsCount(item),
        };
      });
    },
    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
    itemsListColumnPersistKey() {
      // v2 (currency sell): product is the sticky anchor and customer
      // defaults after profit; ignore pre-v2 saved column order for that route.
      var suffix = this.isCurrencySellReport ? "-v2" : "";
      return (
        "invoice-items-list-columns" +
        suffix +
        "-" +
        (this.$route.name || "itemsList")
      );
    },
    visibleTagCount() {
      var tagsHeader = (this.headers || []).find(function (header) {
        return header && header.value === "tags";
      });
      var width = Number(tagsHeader && tagsHeader.width) || 95;
      // Reserve ~38px for the "+N" trigger and cell padding; each tag
      // chip takes an 86px slot (max-width) plus the 4px flex gap.
      return Math.max(1, Math.floor((width - 38) / 90));
    },
    itemsListColumnAnchor() {
      // Currency sell report pins product; other item lists pin customer.
      return this.isCurrencySellReport
        ? "product.name"
        : "head.customer.name";
    },
    itemsListLockedColumns() {
      // Fixed sticky block through anchor column (no unpin/drag)
      var locked = ["actions", "head.id", "head.number"];
      // Currency sell report hides document number.
      if (!this.isCurrencySellReport) {
        locked.push("head.doc_header.number");
      }
      locked.push(this.itemsListColumnAnchor);
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    itemsListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.itemsListLockedColumns,
        anchor: this.itemsListColumnAnchor,
        minWidth: 60,
        persistKey: this.itemsListColumnPersistKey,
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type === "purchase" || app.type === "returnSell") {
          if (s.value === "cost" || s.value === "profit") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.count += parseFloat(d.count);
          acc.fee += parseFloat(d.fee);
          acc.discount += parseFloat(d.discount);
          acc.tax += parseFloat(d.tax);
          acc.sumCurrency += parseFloat(d.sumCurrency);
          acc.sum += parseFloat(d.sumMainCurrency);
          acc.cost += parseFloat(d.cost);
          acc.profit += parseFloat(d.profit);
          return acc;
        },
        {
          count: 0,
          fee: 0,
          discount: 0,
          tax: 0,
          sumCurrency: 0,
          sum: 0,
          cost: 0,
          profit: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    reportCurrency(val) {
      if (!this.isCurrencySellReport) return;
      if (val && val.symbol) {
        this.moneyOptions = {
          ...this.moneyOptions,
          suffix: " " + val.symbol,
        };
      } else {
        this.moneyOptions = {
          ...this.moneyOptions,
          suffix: "",
        };
      }
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
    isCurrencySellReport(val) {
      if (val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
  },
  activated() {
    // this.getItems()
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  beforeMount() {
    if (this.$route.name === "sellItemsList") {
      this.type = "sell";
    }
    if (this.$route.name === "sellCurrencyItemsList") {
      this.type = "sell";
    }
    if (this.$route.name === "presaleItemsList") {
      this.type = "presale";
    }
    if (this.$route.name === "purchaseItemsList") {
      this.type = "purchase";
    }
    if (this.$route.name === "returnPurchaseItemsList") {
      this.type = "returnPurchase";
    }
    if (this.$route.name === "returnSellItemsList") {
      this.type = "returnSell";
    }

    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "head.id",
      },
      {
        text: this.$t("number"),
        value: "head.number",
      },
      {
        text: this.$t("documentNumber"),
        value: "head.doc_header_number",
      },
      {
        text: this.$t("customer-name"),
        value: "head.customer_name",
      },
      {
        text: this.$t("date"),
        value: "head.date",
      },
      {
        text: this.$t("product"),
        value: "product.name",
      },
      {
        text: this.$t("unit"),
        value: "product.unit_fame",
        type: "number",
      },
      {
        text: this.$t("count"),
        value: "count",
        type: "number",
        sum: true,
      },
      {
        text: this.$t("fee"),
        value: "fee",
        type: "number",
        sum: true,
      },
      // {
      //   text: this.$t('discount'),
      //   value: 'discount',
      //   type: 'number'
      // },
      // {
      //   text: this.$t('tax'),
      //   value: 'tax',
      //   type: 'number'
      // },
      // {
      //   text: this.$t('sum') + '(' + this.$t('currency') + ')',
      //   value: 'sumCurrency',
      //   type: 'number',
      //   sum: true
      // },
      {
        text: this.$t("sum"),
        value: "sumCurrency",
        type: "number",
        sum: true,
      },
    ];

    var customerHeader = {
      text: this.$t("customer-name"),
      sortable: false,
      value: "head.customer.name",
    };
    var dateHeader = {
      text: this.$t("date"),
      sortable: false,
      value: "head.date",
    };
    var productHeader = {
      text: this.$t("product"),
      sortable: false,
      value: "product.name",
    };
    // Currency sell: pin product (not customer); default customer after profit.
    var leadingIdentityHeaders = this.isCurrencySellReport
      ? [productHeader, dateHeader]
      : [customerHeader, dateHeader, productHeader];
    var trailingAfterProfitHeaders = this.isCurrencySellReport
      ? [customerHeader]
      : [];
    var docNumberHeader = {
      text: this.$t("number") + " " + this.$t("document"),
      sortable: true,
      value: "head.doc_header.number",
      table: "doc_header.number",
    };
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("id"),
        sortable: true,
        value: "head.id",
        table: "invoice_header.id",
      },
      {
        text: this.$t("number"),
        sortable: true,
        value: "head.number",
        table: "invoice_header.number",
      },
    ]
      .concat(this.isCurrencySellReport ? [] : [docNumberHeader])
      .concat(leadingIdentityHeaders)
      .concat([
        {
          text: this.$t("unit"),
          sortable: false,
          value: "product.unit.fame",
        },
        {
          text: this.$t("count"),
          sortable: true,
          value: "count",
          table: "invoice_articles.count",
          align: "center",
        },
        {
          text: this.$t("fee"),
          sortable: true,
          value: "fee",
          table: "invoice_articles.fee",
          align: "center",
        },
        {
          text: this.$t("discount"),
          sortable: true,
          value: "discount",
          table: "invoice_articles.discount",
          align: "center",
        },
        {
          text: this.$t("tax"),
          sortable: true,
          value: "tax",
          table: "invoice_articles.tax",
          align: "center",
        },
        {
          text: this.$t("sum") + "(" + this.$t("currency") + ")",
          sortable: false,
          value: "sumCurrency",
          align: "center",
        },
        {
          text: this.$t("sum"),
          sortable: false,
          value: "sum",
          align: "center",
        },
        {
          text: this.$t("pricingFinish"),
          sortable: false,
          value: "cost",
          align: "center",
        },
        {
          text: this.$t("profit"),
          sortable: false,
          value: "profit",
          align: "center",
        },
      ])
      .concat(trailingAfterProfitHeaders)
      .concat([
        {
          text: this.$t("serials"),
          sortable: false,
          value: "serialsCount",
          align: "center",
        },
        {
          text: this.$t("tag"),
          sortable: false,
          value: "tags",
          align: "center",
          width: 95,
          minWidth: 90,
        },
        {
          text: this.$t("content"),
          sortable: false,
          value: "content",
        },
        {
          text: this.$t("dkpc"),
          sortable: false,
          value: "dkpc",
        },
        {
          text: this.$t("woocommerce"),
          sortable: false,
          value: "woocommerce",
        },
        {
          text: this.$t("registerar"),
          sortable: false,
          value: "user.name",
        },
      ]);
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    reorderPinnedHeaders(this.headers, {
      locked: this.itemsListLockedColumns,
      anchor: this.itemsListColumnAnchor,
    });
    this.loadItemsListColumnSettings();
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
  },
  mounted() {
    this.getItems();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {

    resetFilters() {
      var app = this;
      [
        "account", "product", "currencyFilter",
        "fromAmount", "toAmount", "fromNumber", "toNumber",
        "fromDate", "toDate", "tag", "sellStatus",
        "group", "cat1", "cat2", "branch", "entrepot",
        "accountCategory", "registerar",
      ].forEach(function (k) {
        app[k] = null;
      });
    },
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null ||
          summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl
        ? tableEl.querySelector(".v-data-footer")
        : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadItemsListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.itemsListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.itemsListLockedColumns,
          anchor: app.itemsListColumnAnchor,
        });
        // Widths saved before the tags column got a larger minimum
        // would otherwise keep it narrower than the new minWidth.
        var tagsHeader = app.headers.find(function (header) {
          return header && header.value === "tags";
        });
        if (tagsHeader && Number(tagsHeader.width) < 90) {
          tagsHeader.width = 90;
        }
        app.$forceUpdate();
      });
    },
    articleSerials(item) {
      return item?.product?.serial || [];
    },
    serialsCount(item) {
      return this.articleSerials(item).length;
    },
    onSerialsClick(item) {
      this.serialsDialogItem = item;
      this.serialsDialog = true;
    },
    calculateCurrencyReport() {
      if (!this.canCalculateCurrency) return;
      this.appliedReportCurrency = this.reportCurrency;
      this.page = 1;
      this.getItems();
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    onCurrencyAutocompleteFocusOut() {
      var app = this;
      this.$nextTick(function () {
        var root = app.$el && app.$el.querySelector
          ? app.$el.querySelector(".currency-report-kpi__autocomplete")
          : null;
        if (root && root.contains(document.activeElement)) return;
        app.currencyAutocompleteFocused = false;
      });
    },
    openComponent(component, id) {
      this.dialogData = {
        name: component,
        id: id,
      };
      this.innerComponent = true;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: this.type + "Edit", params: { id: item.head.uid } });
    },
    print(item) {
      this.printId = item.head.uid;
      this.invoicePrintDialog = true;
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "invoiceReport", {
          params: {
            select: app.isCurrencySellReport ? "itemsCurrency" : "items",
            search: app.search,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            accountCategory: app.accountCategory,
            entrepot: app.entrepot,
            branch: app.branch,
            product: app.product,
            account: app.account,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromAmount: app.fromAmount,
            registerar: app.registerar,
            toAmount: app.toAmount,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            currency: app.currencyFilter,
            currency_amount: app.isCurrencySellReport ? app.currencyAmount : null,
            currency_id: app.isCurrencySellReport
              ? app.reportCurrency && app.reportCurrency.id
                ? app.reportCurrency.id
                : app.reportCurrency
              : null,
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "invoice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            deleteItems: app.selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          type: app.$t(d.head.type),
          id: d.head.id,
          number: d.head.number,
          customer: d.head && d.head.customer ? d.head.customer.name : 0,
          product: d.product ? d.product.name : 0,
          code: d.product ? d.product.code : app.$t("haveNot"),
          unit: d.product && d.product.unit ? d.product.unit.name : 0,
          date: d.head ? d.head.date : 0,
          branch: d.head && d.head.branch ? d.head.branch.name : app.$t("haveNot"),
          internal_code:
            d.head && d.head.branch && d.head.branch.internal_code
              ? d.head.branch.internal_code
              : app.$t("haveNot"),
          currency: d.head && d.head.currency ? d.head.currency.name : 0,
          count: d.count ? app.$numberFormat(d.count, 3) : 0,
          fee: app.$numberFormat(d.fee ? d.fee : 0),
          discount: app.$numberFormat(d.discount),
          tax: app.$numberFormat(d.tax),
          cost: app.$numberFormat(d.cost),
          profit: app.$numberFormat(d.profit),
          content: d.content,
          dkpc: d.productIntegrator ? d.productIntegrator.digikalaVariantId : null,
          woocommerceId: d.productIntegrator ? d.productIntegrator.woocommerceId : null,
          woocommerceVariantId: d.productIntegrator
            ? d.productIntegrator.woocommerceVariantId
            : null,
          user: d.user ? d.user.name : "",
          status: d.head.tax_payer ? app.$t(d.head.tax_payer.status) : "",
          taxId: d.head.tax_payer ? d.head.tax_payer.taxid : "",
          //add total currency and total rial to excel//
          [app.$t("sum") + " (" + app.$t("currency") + ")"]: app.$numberFormat(
            d.sumCurrency,
            "currency",
            d.head?.currency?.decimal
          ),
          [app.$t("sum") + " (" + app.$t("rial") + ")"]: app.$numberFormat(
            d.sumMainCurrency ? d.sumMainCurrency : 0,
            "currency",
            d.head?.currency?.decimal
          ),
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
/* Numbers stay center (align:center on header); titles should not sit mid-column */
::v-deep
  .app-list-table.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th.text-center {
  text-align: start !important;
}
/* Icon on RTL start (right), then content — parity with invoice list */
.invoice-list-icon-cell {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0;
  width: 100%;
  min-width: 0;
}
.invoice-list-icon-cell:has(.invoice-list-icon-cell__icon:not(:empty)) {
  gap: 4px;
}
.invoice-list-icon-cell__icon {
  flex: 0 0 24px;
  width: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}
.invoice-list-icon-cell__icon:empty {
  flex: 0 0 0;
  width: 0;
  min-width: 0;
  overflow: hidden;
}
.invoice-list-icon-cell__body {
  flex: 1 1 auto;
  min-width: 0;
  text-align: start;
}
.invoice-list-icon-cell__btn {
  width: 22px !important;
  height: 22px !important;
  margin: 0 !important;
}
.invoice-list-icon-cell__glyph {
  font-size: 18px !important;
}
.invoice-list-customer-link {
  text-decoration: none;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}

.currency-report-summary-row {
  margin-top: 2px !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.currency-report-table-col {
  margin-top: 4px !important;
}
.currency-report-kpis {
  display: flex !important;
  flex-direction: row !important;
  align-items: stretch !important;
  justify-content: flex-start !important;
  flex-wrap: nowrap !important;
  gap: 8px !important;
  column-gap: 8px !important;
  margin-bottom: 0;
  width: fit-content;
  max-width: 100%;
  height: 32px;
}
.currency-report-kpi {
  flex: 0 0 160px;
  width: 160px;
  min-width: 160px;
  max-width: 160px;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  overflow: hidden;
}
.currency-report-kpi-action {
  flex: 0 0 auto;
  display: flex;
  align-items: stretch;
  justify-content: center;
  align-self: stretch;
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  margin-inline: 0 !important;
  border: none;
  background: transparent;
  overflow: hidden;
}
.currency-report-kpi-action ::v-deep .v-btn.currency-report-calc-btn,
.currency-report-kpi-action
  ::v-deep
  .v-btn.currency-report-calc-btn.v-size--default,
.currency-report-kpi-action
  ::v-deep
  .v-btn.currency-report-calc-btn:not(.v-btn--round).v-size--default {
  height: 100% !important;
  min-height: 32px !important;
  max-height: 32px !important;
  width: auto !important;
  margin: 0 !important;
  margin-inline: 0 !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  line-height: 32px !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
}
.currency-report-kpi-action ::v-deep .currency-report-calc-btn .v-btn__content {
  height: 100% !important;
  max-height: 32px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.currency-report-kpi-action ::v-deep .currency-report-calc-btn .v-icon {
  font-size: 15px !important;
  height: 15px !important;
  width: 15px !important;
  margin-inline-end: 4px !important;
  margin-inline-start: 0 !important;
}
.currency-report-kpi__field {
  width: 100%;
  display: flex;
  align-items: stretch;
  min-width: 0;
  height: 32px;
}
/* autocomplete root is a bare <div> — force it to fill the kpi width */
.currency-report-kpi__field > *,
.currency-report-kpi__field ::v-deep > div {
  width: 100% !important;
  max-width: 100% !important;
  flex: 1 1 auto;
  min-width: 0;
  display: block;
}
.currency-report-kpi__field ::v-deep .money-root,
.currency-report-kpi__field ::v-deep .v-input,
.currency-report-kpi__field ::v-deep .v-autocomplete {
  width: 100% !important;
  max-width: 100% !important;
  height: 32px !important;
  min-height: 32px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 13px !important;
}
.currency-report-kpi__field ::v-deep .v-input__control {
  min-height: 32px !important;
  height: 32px !important;
}
.currency-report-kpi__field ::v-deep .v-input__slot,
.currency-report-kpi__field
  ::v-deep
  .v-text-field--outlined.v-input--dense
  .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
  margin-bottom: 0 !important;
  padding: 0 8px !important;
  align-items: center !important;
  box-shadow: none !important;
  background: #fff !important;
}
.currency-report-kpi__field ::v-deep .v-text-field--outlined fieldset {
  top: 0 !important;
  border: 1px solid #bdbdbd !important;
  border-width: 1px !important;
  color: #bdbdbd !important;
}
.currency-report-kpi__field
  ::v-deep
  .v-input--is-focused.v-text-field--outlined
  fieldset {
  border-color: #9e9e9e !important;
  border-width: 1px !important;
}
.currency-report-kpi__field ::v-deep .v-text-field--outlined fieldset legend {
  display: none !important;
  width: 0 !important;
}
.currency-report-kpi__field ::v-deep .v-text-field__details {
  display: none !important;
  min-height: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.currency-report-kpi__field ::v-deep .v-input__append-inner,
.currency-report-kpi__field ::v-deep .v-input__prepend-inner {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-self: center !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 32px !important;
  max-height: 32px !important;
}
.currency-report-kpi__field ::v-deep .v-input__icon {
  height: 32px !important;
  min-height: 32px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.currency-report-kpi__field ::v-deep .v-label {
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.2 !important;
  height: auto !important;
  right: 8px !important;
  left: auto !important;
  text-align: right !important;
  max-width: calc(100% - 16px);
  white-space: nowrap;
  font-size: 13px !important;
}
.currency-report-kpi__field
  ::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  .v-label--active {
  top: 50% !important;
  transform: translateY(-50%) !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
.currency-report-kpi__field ::v-deep input::placeholder {
  opacity: 1;
  color: rgba(0, 0, 0, 0.45);
  text-align: right;
  font-size: 13px;
}
.currency-report-kpi__field ::v-deep input {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 30px !important;
  font-size: 13px !important;
  text-align: right !important;
  direction: rtl !important;
}
.currency-report-kpi__field ::v-deep .v-text-field__suffix {
  margin-inline-start: 2px !important;
  padding-inline-start: 0 !important;
  font-size: 12px !important;
}
.currency-report-kpi__field ::v-deep .v-text-field__slot {
  display: flex !important;
  align-items: center !important;
  direction: ltr !important;
  justify-content: flex-end !important;
  text-align: right !important;
  height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
}
.currency-report-kpi__autocomplete {
  position: relative;
}
.currency-report-kpi__placeholder {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
  line-height: 1;
  pointer-events: none;
  z-index: 2;
  white-space: nowrap;
}
.currency-report-kpi__autocomplete ::v-deep .v-label {
  display: none !important;
}
.currency-report-kpi__autocomplete ::v-deep .v-input__append-inner,
.currency-report-kpi__autocomplete ::v-deep .v-input__prepend-inner {
  display: none !important;
  width: 0 !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.currency-report-kpi__autocomplete ::v-deep .v-select__selections {
  justify-content: flex-end !important;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 32px !important;
}
.currency-report-kpi__autocomplete ::v-deep .v-select__selection,
.currency-report-kpi__autocomplete ::v-deep .v-select__selections input {
  margin: 0 !important;
  padding: 0 !important;
  text-align: right !important;
  max-width: 100% !important;
  font-size: 13px !important;
}
.invoice-list-details-trigger {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  line-height: 1.2;
  color: #5c6bc0;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
}
.invoice-list-details-trigger:hover {
  text-decoration: none;
}
.invoice-list-tags-mini {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}
.invoice-list-tags-mini .invoice-list-details-trigger {
  flex: 0 0 auto;
}
.invoice-list-tags-mini__chip {
  border-radius: 10px !important;
  flex: 0 1 auto;
  width: auto !important;
  max-width: 100%;
  min-width: 0;
}
.invoice-list-tags-mini__chip ::v-deep .v-chip__content {
  min-width: 0;
  max-width: 100%;
  justify-content: center;
}
.invoice-list-tags-mini__chip .px-1 {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>

<style>
/* Unscoped: equal height for currency report controls (beats Vuetify defaults) */
.currency-report-kpis {
  align-items: stretch !important;
  gap: 8px !important;
  height: 32px !important;
}
.currency-report-kpi,
.currency-report-kpi-action {
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
}
.currency-report-kpi .v-input,
.currency-report-kpi .v-input__control,
.currency-report-kpi .v-text-field--outlined.v-input--dense .v-input__slot,
.currency-report-kpi .v-input__slot {
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
}
.currency-report-kpi-action .v-btn.currency-report-calc-btn,
.currency-report-kpi-action
  .v-btn.currency-report-calc-btn:not(.v-btn--round).v-size--default {
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
}
</style>
